(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["belameur-buy-now"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('belameur-buy-now')) {
  customElements.define('belameur-buy-now', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.button = this.querySelector('button');
      this.error = this.querySelector('[role="alert"]');
      this.addButton = this.form?.querySelector('.add-cart-button[name="add"]');
      if (!this.form || !this.addButton || this.initialized) return;
      this.initialized = true;
      this.label = this.button.textContent;
      this.busy = false;
      this.sync = () => { this.button.disabled = this.busy || this.addButton.disabled; };
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.addButton, { attributes: true, attributeFilter: ['disabled'] });
      this.button.addEventListener('click', () => this.buy());
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.initialized = false;
    }
    async buy() {
      if (this.busy || this.addButton.disabled || !this.form.reportValidity()) return;
      const terms = this.form.querySelector('[name="conditions"]');
      if (terms && !terms.checked) { terms.focus(); return; }
      const data = new FormData(this.form);
      if (!data.get('id')) return;
      const details = this.form.closest('.bls__product-details-infor');
      details?.querySelectorAll('product-property input').forEach(input => {
        if (input.disabled || !input.name) return;
        if (input.type === 'file' && input.files[0]) data.set(input.name, input.files[0]);
        else if (input.type !== 'file' && input.value) data.set(input.name, input.value);
      });
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.button.textContent = this.dataset.loading;
      this.error.hidden = true;
      const root = (this.dataset.root || '/').replace(/\/?$/, '/');
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json' }, body: data
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          this.error.textContent = typeof result.description === 'string' ? result.description : this.dataset.error;
          this.error.hidden = false;
          this.reset();
          return;
        }
        window.location.assign(root + 'checkout');
      } catch {
        this.error.textContent = this.dataset.error;
        this.error.hidden = false;
        this.reset();
      }
    }
    reset() {
      this.busy = false;
      this.button.removeAttribute('aria-busy');
      this.button.textContent = this.label;
      this.sync();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["belameur-sizing"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('belameur-sizing')){
 customElements.define('belameur-sizing',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   const dialog=this.querySelector('dialog'),brand=this.querySelector('[data-brand]'),unit=this.querySelector('[data-unit]'),form=this.querySelector('form'),result=this.querySelector('[data-result]'),source=this.querySelector('[data-source]'),chart=this.querySelector('[data-chart]'),note=this.querySelector('[data-brand-note]'),missing=this.querySelector('[data-unavailable]'),inputs=[...this.querySelectorAll('[data-measure]')];
   const charts=JSON.parse(this.querySelector('[data-charts]').textContent),msg=JSON.parse(this.querySelector('[data-messages]').textContent);
   const vendor=this.dataset.vendor==='Belameur Dresses'?'Belameur':this.dataset.vendor;
   if(charts[vendor])brand.value=vendor;else brand.value='Unbranded';
   const clear=()=>{result.hidden=true;result.replaceChildren();};
   const refresh=()=>{
    clear();
    const data=charts[brand.value],usable=data.rows.length>0;
    form.hidden=!usable;missing.hidden=!!data.rows.length;chart.hidden=!data.rows.length;
    note.textContent=data.note?msg[data.note]:'';
    source.hidden=!data.url;if(data.url)source.href=data.url;
    const body=this.querySelector('tbody');body.replaceChildren();
    for(const row of data.rows){const tr=document.createElement('tr');row.forEach((v,i)=>{const td=document.createElement('td');td.textContent=i===0?v:(unit.value==='cm'?Math.round(v*25.4)/10:v)+' '+unit.value;tr.append(td);});body.append(tr);}
   };
   refresh();brand.addEventListener('change',refresh);
   let lastUnit=unit.value;
   unit.addEventListener('change',()=>{for(const input of inputs){if(input.value){const v=Number(input.value);input.value=String(Math.round((lastUnit==='in'?v*2.54:v/2.54)*10000)/10000);}}lastUnit=unit.value;refresh();});
   inputs.forEach(input=>input.addEventListener('input',()=>{clear();}));
   document.addEventListener('click',event=>{const trigger=event.target.closest('[data-bm-size]');if(!trigger)return;event.preventDefault();this.opener=trigger;if(!dialog.open)dialog.showModal();});
   this.querySelector('[data-close]').addEventListener('click',()=>dialog.close());
   dialog.addEventListener('close',()=>this.opener?.focus());
   form.addEventListener('submit',event=>{
    event.preventDefault();clear();if(!form.reportValidity())return;
    const values=inputs.map(i=>Number(i.value)/(unit.value==='cm'?2.54:1)),rows=charts[brand.value].rows;
    const show=(heading,text)=>{const strong=document.createElement('strong'),p=document.createElement('p');strong.textContent=heading;p.textContent=text;result.append(strong,p);result.hidden=false;};
    if(values.some(v=>!Number.isFinite(v)||v<=0)){show(msg.invalid,'');return;}
    if(values.some((v,i)=>v<rows[0][i+1]-.0001||v>rows[rows.length-1][i+1]+.0001)){show(msg.outside,'');return;}
    const matches=values.map((v,i)=>rows.findIndex(r=>r[i+1]+.0001>=v)),idx=Math.max(...matches);
    show(msg.result.replace('[size]',rows[idx][0]),new Set(matches).size>1?msg.split:msg.normal);
   });
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
